const COLLATOR = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

/**
 * Natural alphanumeric comparator. Numeric segments sort by value (2 < 10 < 100),
 * leading-zero sequences sort numerically (001 < 002 < 010), case-insensitive.
 */
export const alphanumericCompare = (a: string, b: string): number => COLLATOR.compare(a, b);
